import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { WizardButtonActions } from '../../constants';
import { WizardButtonOptions } from '../../models/wizard-buttons-options.model';

@Component({
  selector: 'com-wizard-buttons',
  templateUrl: './wizard-buttons.component.html',
  styleUrls: ['./wizard-buttons.component.scss'],
  animations: [
    trigger('pulseNext', [
      state('updating', style({ fontSize: '2.5rem', height: '50px', backgroundColor: 'silver' })),
      transition('* => *', [animate('0.5s ease-in-out')]),
    ]),
  ],
})
export class WizardButtonsComponent implements OnInit {
  @Input() stepper: MatStepper;
  @Input() options: WizardButtonOptions;
  @Input() pulseNext: boolean;
  @Input() disabled: boolean = false;
  @Output() action = new EventEmitter<string>();

  ngOnInit(): void {
    if (!this.options) {
      this.options = new WizardButtonOptions();
    }
  }

  pulseNextButton() {
    this.pulseNext = true;
    setTimeout(() => {
      this.pulseNext = false;
    }, 1000);
  }

  previousStep(): void {
    this.action.emit(WizardButtonActions.Previous);
  }
  nextStep(): void {
    this.action.emit(WizardButtonActions.Next);
  }
  submit(): void {
    this.action.emit(WizardButtonActions.Submit);
  }
}
